export default function Instagram({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22.996"
      height="22.996"
      viewBox="0 0 22.996 22.996"
      {...props}
    >
      <path d="M16.372 0H6.624A6.632 6.632 0 0 0 0 6.624v9.748a6.632 6.632 0 0 0 6.624 6.624h9.748a6.632 6.632 0 0 0 6.624-6.624V6.624A6.632 6.632 0 0 0 16.372 0Zm4.278 16.372a4.283 4.283 0 0 1-4.278 4.278H6.624a4.282 4.282 0 0 1-4.277-4.278V6.624a4.282 4.282 0 0 1 4.277-4.278h9.748a4.283 4.283 0 0 1 4.278 4.278Z" />
      <path d="M11.498 6.158a5.34 5.34 0 1 0 5.34 5.34 5.346 5.346 0 0 0-5.34-5.34Zm0 8.225a2.885 2.885 0 1 1 2.885-2.885 2.888 2.888 0 0 1-2.885 2.884Z" />
      <path d="M17.483 3.843a1.584 1.584 0 1 0 1.583 1.584 1.584 1.584 0 0 0-1.583-1.584Z" />
    </svg>
  );
}
